import axios from 'axios';

class ApiService {
  // Mock function to load the access token (replace this with your actual implementation)
  async loadAccessToken() {
    return localStorage.getItem('accessToken');
  }

  // Mock function to get the user ID (replace this with your actual implementation)
  async getDoctorId() {
    return localStorage.getItem('doctorId');
  }

  // API call to get payment entry status
  async getPaymentEntryStatus(assessmentId) {
    try {
      // Get access token and user ID
      const accessToken = await this.loadAccessToken();
      const userId = await this.getDoctorId();

      // Encode query parameters
      const encodedLoginId = encodeURIComponent(userId);
      const encodedAssessmentId = encodeURIComponent(assessmentId);

      const url = `${process.env.REACT_APP_BASE_URL}/payment_entry_status?login_id=${encodedLoginId}&assessment_id=${encodedAssessmentId}`;

      // Define headers
      const headers = {
        accessToken: accessToken,
      };

      // Make API request
      const response = await axios.get(url, { headers });

      // Return the response data based on the status code
      if (response.status === 200 || response.status === 404) {
        return response.data;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error fetching payment status:', error);
      return '';
    }
  }
}

export default ApiService;
